import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCommunity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M17.37 23.372c-1.084 1.16-3.03.394-3.03-1.194v-3.51a.75.75 0 1 1 1.5 0v3.51a.25.25 0 0 0 .433.17l4.679-5.01a.75.75 0 0 1 1.096 1.024l-4.678 5.01Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M5 3.3a2.75 2.75 0 0 0-2.75 2.75v10.4A2.75 2.75 0 0 0 5 19.2h15a2.75 2.75 0 0 0 2.75-2.75V6.05A2.75 2.75 0 0 0 20 3.3H5ZM3.75 6.05c0-.69.56-1.25 1.25-1.25h15c.69 0 1.25.56 1.25 1.25v10.4c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25V6.05Zm4.818 6.793a.75.75 0 0 0-.772 1.287 9.143 9.143 0 0 0 9.408 0 .75.75 0 0 0-.772-1.287 7.643 7.643 0 0 1-7.864 0Z"
    />
    <path
      fill="#F7A600"
      d="M8.614 11.141a1.295 1.295 0 1 0 0-2.59 1.295 1.295 0 0 0 0 2.59Zm7.773 0a1.295 1.295 0 1 0 0-2.59 1.295 1.295 0 0 0 0 2.59Z"
    />
  </svg>
);
export default SvgTwoColorCommunity;
